/**
 * A stable document id for a subscription, derived from its endpoint.
 *
 * The point is idempotence. A browser re-issues the *same* endpoint every time
 * `pushManager.subscribe()` is called with the same key, and the app calls it on
 * every launch to heal an expired subscription. Keyed by a random id, that
 * would grow a new document per launch and the check-in would be delivered to
 * one device fifty times. Keyed by the endpoint, re-subscribing overwrites.
 *
 * FNV-1a over the endpoint rather than the endpoint itself: endpoint URLs
 * contain `/`, which is not legal in a Firestore document id, and can run past
 * 350 characters. A 64-bit digest collides at a rate that is meaningless for
 * the handful of devices one account will ever have.
 */
export function subscriptionId(endpoint) {
    // Two 32-bit FNV-1a lanes with different offset bases, concatenated. JS
    // bitwise operators are 32-bit, so this is the honest way to reach 64 bits
    // without BigInt.
    let h1 = 0x811c9dc5;
    let h2 = 0x01000193;
    for (let i = 0; i < endpoint.length; i++) {
        const c = endpoint.charCodeAt(i);
        h1 = Math.imul(h1 ^ c, 0x01000193);
        h2 = Math.imul(h2 ^ c, 0x811c9dc5);
    }
    const hex = (n) => (n >>> 0).toString(16).padStart(8, "0");
    return hex(h1) + hex(h2);
}
//# sourceMappingURL=push.js.map